<p-toast></p-toast>
<div class="mat-elevation-z8">
    <p-footer>
        <div class="ui-helper-clearfix" style="margin-left:85%;">
            <button type="button" pButton style="float:left" (click)="showDialogToAdd()"
                label="Add Speciality"></button>
        </div>
    </p-footer>
    <br><br>

    <div class="table-responsive text-center justify-content-center"
        style="font-size:14px; margin-bottom: 20px;text-align: center;vertical-align: center;">
        <p-table #dt1 [value]="departments" dataKey="serial" tablestyleClass="p-datatable-customers" [rows]="10"
            [paginator]="true" [showCurrentPageReport]="true" [scrollable]="true" [loading]="loading"
            [autoLayout]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [rowsPerPageOptions]="[25,50,100]" [globalFilterFields]="['specialty_name']" [style]="{'width':'100%'}">
            <ng-template pTemplate="caption">
                <div class="table-header float-right">

                    <div class="ui-table-globalfilter-container">
                        <input type="text" pInputText placeholder="Search by Speciality Name"
                            (input)="dt1.filterGlobal($event.target.value, 'contains')"
                            style="width:250px;margin-left:75%;">
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 10%;text-align: center;" pSortableColumn="serial"><b>Sr.No</b>
                        <p-sortIcon field="serial"></p-sortIcon>
                    </th>
                    <th style="width: 20%;" pSortableColumn="specialty_name"><b>Speciality</b>
                        <p-sortIcon field="specialty_name"></p-sortIcon>
                    </th>
                    <th style="width: 30%;"><b>Image</b></th>
                    <th style="width: 18%; text-align: center;" pSortableColumn="is_supported"><b>Status</b>
                        <p-sortIcon field="is_supported"></p-sortIcon>
                    </th>
                    <th style="width: 12%; text-align: center;" pSortableColumn="featured_id" *ngIf="this.is_primary_provider"><b>Featured</b>
                        <p-sortIcon field="featured_id"></p-sortIcon>
                    </th>
                    <th style="width: 10%; text-align: center;"><button pButton type="button" icon="pi pi-cog"></button>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-department>
                <tr>
                    <td style="width: 10%; text-align: center;">{{department.serial}}</td>

                    <td style="width: 20%;">{{department.specialty_name}}</td>

                    <td style="width: 30%;">
                        <img class="circle-icon"
                            [src]="(department.speciality_url)?department.speciality_url:'./assets/images/speciality/default_speciality.png'"
                            style="height: 100px;">
                    </td>
                    <td style="width: 18%; text-align: center;">
                        <span> {{department.is_supported ? 'Active' : 'Inactive'}} </span>
                    </td>
                    <td style="width: 12%; text-align: center;" *ngIf="this.is_primary_provider">
                        <span> {{department.featured_id ? 'Yes' : 'No'}} </span>
                    </td>
                    <td style="width: 10%; text-align: center;">
                        <button pButton type="button" class="ui-button-warning" icon="pi pi-pencil"
                            (click)="edit(department)"></button>
                        <button pButton type="button" class="ui-button-danger" icon="pi pi-trash"
                            (click)="confirmDelete($event,department)" style="margin-left: .5em"></button>
                    </td>
                </tr>
            </ng-template>
        </p-table>
        <div class="row container justify-content-center text-center alert alert-danger"
            *ngIf="this.table_response.success!=null && this.table_response.success==false">
            <p *ngIf="this.table_response.error!=null">{{this.table_response.error.message}}</p>
            <div *ngIf="this.table_serverError?.error!=null && this.table_serverError?.statusCode!=500">
                <p *ngFor="let message of this.table_serverError?.message">{{message}}</p>
            </div>
            <div *ngIf="this.table_serverError?.error!=null && this.table_serverError?.statusCode==500">
                <p>{{this.table_serverError?.message}}</p>
            </div>

        </div>

    </div>
</div>
<div class="mat-elevation-z8">
    <p-confirmDialog key="confirm-delete-speciality" header="Delete Speciality" acceptLabel="Yes" rejectLabel="No"
        [(visible)]="confirmDialogVisible"></p-confirmDialog>
</div>



<p-dialog header="Add Speciality" *ngIf="createDialog" [(visible)]="createDialog" [responsive]="true" showEffect="fade"
    (onHide)="Cancel()" [modal]="true">
    <div class="ui-grid ui-grid-responsive ui-fluid" *ngIf="department">

        <div class="ui-g">
            <div class="ui-g-12 ui-md-4" style="width:40%">
                <label for="Is this Speciality Active"> <b>Speciality Name:</b></label>
            </div>
            <div class="ui-g-12 ui-md-4" style="width:60%"> <input type="text" pInputText size="50"
                    [pKeyFilter]="name_input" placeholder="Enter Speciality" id="specialty_name"
                    [(ngModel)]="department.specialty_name">
            </div>
        </div>
        <div>

            <div class="ui-g">
                <div class="ui-g-12 ui-md-4" style="width:40%">
                    <label for="Is this Speciality Active"> <b>Is this Speciality Active:</b></label>
                </div>
                <div class="ui-g-12 ui-md-4" style="width:30%">
                    <p-radioButton name="status" label="Yes" value="Yes" [(ngModel)]="selectedStatus"
                        (onClick)="onSelectStatus()" required></p-radioButton>
                </div>
                <div class="ui-g-12 ui-md-4" style="width:30%">
                    <p-radioButton name="status" label="No" value="No" [(ngModel)]="selectedStatus"
                        (onClick)="onSelectStatus()" required></p-radioButton>
                </div>

            </div>
            <div class="ui-g" *ngIf="this.is_primary_provider">
                <div class="ui-g-12 ui-md-4" style="width:40%" >
                    <label for="Is this Speciality Active"> <b>Do you want this specialty to be featured ?</b></label>
                </div>
                <div class="ui-g-12 ui-md-4" style="width:30%">
                    <p-radioButton name="featured" label="Yes" value="Yes" [(ngModel)]="selectedFeatured"
                        (onClick)="onSelectFeatured()" [disabled]="!this.featuredField"></p-radioButton>
                </div>
                <div class="ui-g-12 ui-md-4" style="width:30%">
                    <p-radioButton name="featured" label="No" value="No" [(ngModel)]="selectedFeatured"
                        (onClick)="onSelectFeatured()" [disabled]="!this.featuredField"></p-radioButton>
                </div>

            </div>
            <div class="ui-g">
                <div class="ui-g-12 ui-md-4" style="width:40%"><label for="countries"><b>Countries:</b></label></div>
            </div>
            <div class="ui-g">
                <div class="ui-g-12">
                    <p-multiSelect id="countries" [options]="countries" [style]="{'width': '230px'}" name="countries"
                        [(ngModel)]="selectedCountries" [filter]="true" placeholder="Select">
                    </p-multiSelect>
                </div>
            </div>
            <div class="ui-g">
                <div class="ui-g-12 ui-md-4" style="width:40%"><label for="Speciality Image"><b>Speciality
                            Image:</b></label></div>
            </div>

            <div class="ui-g">
                <div class="ui-g-12">
                    <p-fileUpload name="file" (onSelect)="uploadFiles($event.files)" (onRemove)="clearfile()" [showUploadButton]="false"
                        styleClass="p-fileUpload-label-fix" [showCancelButton]="false" [maxFileSize]="5033165"
                        multiple="false" [fileLimit]="1" accept="image/*">
                    </p-fileUpload>
                </div>
            </div>

            <!--<mat-radio-group aria-label="Select an option">
            <h6> Is this Speciality Active:</h6> 
            <mat-radio-button value="1" style="margin-right: 50px;" (click)="Active($event,department.id-1)">Yes</mat-radio-button>
            <mat-radio-button value="2" (click)="Inactive($event,department.id-1)">No</mat-radio-button>
          </mat-radio-group>-->
        </div>

        <div class="alert alert-danger" role="alert">
            <p class="text-center text-gray-underline"><span class="font-weight-bold">Note</span>: The file type
                supported for Speciality Image are
                JPEG,JPG,PNG.</p>
        </div>

    </div>
    <div class="row container justify-content-center text-center alert alert-danger"
        *ngIf="response.success!=null && response.success==false">
        <p *ngIf="response.error!=null">{{response.error.message}}</p>
        <div *ngIf="serverError?.error!=null && serverError?.statusCode!=500">
            <p *ngFor="let message of serverError?.message">{{message}}</p>
        </div>
        <div *ngIf="serverError?.error!=null && serverError?.statusCode==500">
            <p>{{serverError?.message}}</p>
        </div>

    </div>
    <p-footer>
        <p-progressSpinner *ngIf="this.posting==true"
            [style]="{'width': '25px', 'height': '25px', 'vertical-align' : 'middle'}" strokeWidth="6">
        </p-progressSpinner>
        <button type="button" [disabled]="this.posting==true" style="margin-bottom:10px;margin-right:5px;width:190px;"
            pButton (click)="save()" label="Save"
            [disabled]="(this.department.specialty_name=='' || this.department.is_supported==null) || selectedCountries==null || selectedStatus==null"></button>
        <button type="button" [disabled]="this.posting==true" style="margin-bottom:10px;margin-right:5px;width:190px;"
            pButton (click)="Cancel()" label="Cancel"></button>
    </p-footer>
</p-dialog>
<!-- <ng-template *ngIf="editID!=-1"> -->
<p-dialog header="Edit Speciality" *ngIf="updateDialog" [(visible)]="updateDialog" [responsive]="true" showEffect="fade"
    (onHide)="Cancel()" [modal]="true">
    <div class="ui-grid ui-grid-responsive ui-fluid">

        <div class="ui-g">
            <div class="ui-g-12 ui-md-4" style="width:40%">
                <label for="Is this Speciality Active"> <b>Speciality Name:</b></label>
            </div>
            <div class="ui-g-12 ui-md-4" style="width:60%"> <input type="text" pInputText size="50"
                    [pKeyFilter]="name_input" placeholder="Enter Speciality" id="specialty_name"
                    [(ngModel)]="department.specialty_name">
            </div>
        </div>
        <div>

            <div class="ui-g">
                <div class="ui-g-12 ui-md-4" style="width:40%">
                    <label for="Is this Speciality Active"> <b>Is this Speciality Active:</b></label>
                </div>
                <div class="ui-g-12 ui-md-4" style="width:30%">
                    <p-radioButton name="status" label="Yes" value="Yes" [(ngModel)]="selectedStatus"
                        (onClick)="onSelectStatus()" required></p-radioButton>
                </div>
                <div class="ui-g-12 ui-md-4" style="width:30%">
                    <p-radioButton name="status" label="No" value="No" [(ngModel)]="selectedStatus"
                        (onClick)="onSelectStatus()" required></p-radioButton>
                </div>

            </div>
            <div class="ui-g" *ngIf="this.is_primary_provider">
                <div class="ui-g-12 ui-md-4" style="width:40%" >
                    <label for="Is this Speciality Active"> <b>Do you want this specialty to be featured ?:</b></label>
                </div>
                <div class="ui-g-12 ui-md-4" style="width:30%">
                    <p-radioButton name="featured" label="Yes" value="Yes" [(ngModel)]="selectedFeatured"
                        (onClick)="onSelectFeatured()" [disabled]="!this.featuredField"></p-radioButton>
                </div>
                <div class="ui-g-12 ui-md-4" style="width:30%">
                    <p-radioButton name="featured" label="No" value="No" [(ngModel)]="selectedFeatured"
                        (onClick)="onSelectFeatured()" [disabled]="!this.featuredField"></p-radioButton>
                </div>

            </div>
            <div class="ui-g">
                <div class="ui-g-12 ui-md-4" style="width:40%"><label for="countries"><b>Countries:</b></label></div>
            </div>
            <div class="ui-g">
                <div class="ui-g-12">
                    <p-multiSelect id="countries" [options]="countries" [style]="{'width': '230px'}" name="countries"
                        [(ngModel)]="selectedCountries" [filter]="true" placeholder="Select">
                    </p-multiSelect>
                </div>
            </div>
            <div class="ui-g">
                <div class="ui-g-12 ui-md-4" style="width:40%"><label for="Speciality Image"><b>Speciality
                            Image:</b></label></div>
            </div>

            <div class="ui-g">
                <div class="ui-g-12">
                    <p-fileUpload name="sp_image" (onSelect)="uploadFiles($event.files)" (onRemove)="clearfile()" [showCancelButton]="false"
                        styleClass="p-fileUpload-label-fix" [showUploadButton]="false" [maxFileSize]="5033165"
                        [multiple]="false" [fileLimit]="1" accept="image/*">
                    </p-fileUpload>
                </div>
            </div>

            <!--<mat-radio-group aria-label="Select an option">
              <h6> Is this Speciality Active:</h6> 
              <mat-radio-button value="1" style="margin-right: 50px;" (click)="Active($event,department.id-1)">Yes</mat-radio-button>
              <mat-radio-button value="2" (click)="Inactive($event,department.id-1)">No</mat-radio-button>
            </mat-radio-group>-->
        </div>

        <div class="alert alert-danger" role="alert">
            <p class="text-center text-gray-underline"><span class="font-weight-bold">Note</span>: The file type
                supported for Speciality Image are
                JPEG,JPG,PNG.</p>
        </div>

    </div>
    <div class="row container justify-content-center text-center alert alert-danger"
        *ngIf="response.success!=null && response.success==false">
        <p *ngIf="response.error!=null">{{response.error.message}}</p>
        <div *ngIf="serverError?.error!=null && serverError?.statusCode!=500">
            <p *ngFor="let message of serverError?.message">{{message}}</p>
        </div>
        <div *ngIf="serverError?.error!=null && serverError?.statusCode==500">
            <p>{{serverError?.message}}</p>
        </div>

    </div>
    <p-footer>
        <p-progressSpinner *ngIf="this.posting==true"
            [style]="{'width': '25px', 'height': '25px', 'vertical-align' : 'middle'}" strokeWidth="6">
        </p-progressSpinner>
        <button type="button" [disabled]="this.posting==true" style="margin-bottom:10px;margin-right:5px;width:190px;"
            pButton (click)="update()" label="Update"
            [disabled]="(this.department.specialty_name=='' || this.department.is_supported==null || selectedCountries==null || selectedStatus==null || selectedFeatured==null)"></button>
        <button type="button" [disabled]="this.posting==true" style="margin-bottom:10px;margin-right:5px;width:190px;"
            pButton (click)="Cancel()" label="Cancel"></button>
    </p-footer>
</p-dialog>

<!-- </ng-template> -->